// extracted by mini-css-extract-plugin
export default {"projects":"views__projects__2ozzI","projects-title":"views__projects-title__h2RWY","projectsTitle":"views__projects-title__h2RWY"};